import { useEffect, useRef } from "react";

// O que o menu Exportar e o calendario do periodo tem em comum: fecham com um clique fora, quando o foco
// chega a qualquer sitio fora do involucro (o Tab) e com o Escape. Escuta no documento enquanto `open`,
// porque com o rato o foco pode estar fora do painel. `ref` e o involucro do botao e do painel, e
// `returnFocusTo` o botao. O foco que chega fora fecha sem o mover (o `focusin` do documento, e nao o
// `focusout` do involucro): assim tambem fecha no Safari, onde o Tab salta os botoes e o foco, que estava
// no body, vai para a ligacao ou o campo seguinte. Um clique numa zona sem foco do proprio painel nao
// dispara `focusin`, por isso nao o fecha. O Escape fecha sempre, mas so devolve o foco ao botao quando
// ele estava dentro do involucro: com o foco noutro sitio (o botao de uma nota, por exemplo) deixa-o onde
// esta. `onClose` pode mudar a cada render sem voltar a subscrever.
const usePopover = (ref, { open, onClose, returnFocusTo }) => {
  const close = useRef(onClose);
  close.current = onClose;

  useEffect(() => {
    if (!open) return undefined;
    const onPointerDown = (event) => {
      if (!ref.current?.contains(event.target)) close.current();
    };
    const onFocusIn = (event) => {
      if (!ref.current?.contains(event.target)) close.current();
    };
    const onKeyDown = (event) => {
      if (event.key !== "Escape") return;
      const focusInside = ref.current?.contains(document.activeElement);
      close.current();
      if (focusInside) returnFocusTo.current?.focus();
    };
    document.addEventListener("focusin", onFocusIn);
    document.addEventListener("mousedown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("focusin", onFocusIn);
      document.removeEventListener("mousedown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open, ref, returnFocusTo]);
};

export default usePopover;
